import Cookies from 'js-cookie';

export async function refreshToken() {
	const API = import.meta.env.VITE_API_BASE_URL;

	const refreshId = Cookies.get('refresh_id');
	const session_id = Cookies.get('token');
	if (!refreshId) return null;
	if (!session_id) return null;

	const formData = new FormData();
	formData.append('refresh_id', refreshId);
	formData.append('session_id', session_id);

	try {
		const res = await fetch(`${API}/refresh`, {
			method: 'POST',
			body: formData,
		});

		if (!res.ok) {
			throw new Error(`Refresh error: ${res.status}`);
		}

		const data = await res.json();

		Cookies.set('token', data.data.session_id, { expires: 2 });
		Cookies.set('refresh_id', data.data.refresh_id, { expires: 2 });
		Cookies.set('expire_dt', data.data.expire_dt, { expires: 2 });

		return data;
	} catch (error) {
		console.error('Ошибка refresh:', error);
		return null;
	}
}
